export const Divider = {
  baseStyle: {
    borderColor: "brand.greyQuaternary",
  },
}
